import {
  TableField,
  currencyFormatter4Digits,
  defaultDateFormatter,
  defaultTruncaTexto,
} from "../../table-field";

const nra = {
  key: "NumeroAnoLicitacao",
  label: "Nº/Ano",
  tdClass: ["align-middle, naoQuebrar"],
  thClass: ["text-center, naoQuebrar"],
  sortable: true,
};
const modalidade = {
  key: "Modalidade",
  label: "Modalidade",
  tdClass: ["align-middle, quebrarPorPalavraHard"],
  thClass: ["text-center, naoQuebrar"],
  sortable: true,
};
const objeto = {
  key: "Objeto",
  label: "Objeto",
  tdClass: ["align-middle", "quebrarPorPalavra"],
  thClass: ["text-center, naoQuebrar"],
  sortable: true,
  formatter: defaultTruncaTexto,
};
const valorEstimado = {
  key: "ValorEstimado",
  label: "Valor Estimado",
  tdClass: ["align-middle", "naoQuebrar"],
  thClass: ["text-center", "quebrarPorPalavraHard"],
  sortable: true,
  formatter: currencyFormatter4Digits,
};
const valorLicitado = {
  key: "ValorLicitado",
  label: "Valor Licitado",
  tdClass: ["align-middle", "naoQuebrar"],
  thClass: ["text-center", "quebrarPorPalavraHard"],
  sortable: true,
  formatter: currencyFormatter4Digits,
};
const dtHomologacao = {
  key: "DtHomologacao",
  label: "Dt. Homologação",
  tdClass: ["align-middle", "naoQuebrar"],
  thClass: ["text-center", "quebrarPorPalavraHard"],
  sortable: true,
  formatter: defaultDateFormatter,
};
const situacao = {
  key: "Situacao",
  label: "Situação",
  tdClass: ["align-middle", "quebrarPorPalavraHard"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: true,
};
const actions = {
  key: "actions",
  label: "Ações",
  tdClass: ["align-middle", "col-actions", "min20rem"],
  thClass: "text-center",
  sortable: false,
};

export const fieldsLicitacoesConsulta: TableField[] = [
  nra,
  modalidade,
  objeto,
  situacao,
  actions,
];
export const fieldsLicitacoes: TableField[] = [
  nra,
  modalidade,
  objeto,
  valorEstimado,
  valorLicitado,
  dtHomologacao,
  situacao,
  actions,
];

export const fieldsImportacao: TableField[] = [
  nra,
  modalidade,
  objeto,
  valorEstimado,
  valorLicitado,
];
